const InstagramIcon = ({ color }) => {
  const fillColor = color || "currentColor";
  return (
    <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <path fill={fillColor} d="M20.9583,3h-12c-3.3,0-6,2.7-6,6v12c0,3.3,2.7,6,6,6h12c3.3,0,6-2.7,6-6V9C26.9583,5.7,24.2583,3,20.9583,3z M24.9583,21c0,2.2056-1.7944,4-4,4h-12c-2.2056,0-4-1.7944-4-4V9c0-2.2056,1.7944-4,4-4h12c2.2056,0,4,1.7944,4,4V21z" />
      <path fill={fillColor} d="M15,10c-2.7615,0-5,2.2386-5,5s2.2385,5,5,5c2.7614,0,5-2.2386,5-5S17.7614,10,15,10z M15,18c-1.6542,0-3-1.3458-3-3c0-1.6542,1.3458-3,3-3c1.6542,0,3,1.3458,3,3C18,16.6542,16.6542,18,15,18z" />
      <circle fill={fillColor} cx="21.4166" cy="8.5" r="1.5" />
    </svg>
  )
}

export default InstagramIcon
